import { Skeleton, styled } from '@mui/material';

export const PayoutInfoLoader = styled(Skeleton)(({ theme }) => ({
  height: theme.spacing(3),
  width: '100%',
}));
